<template>
  <v-footer
    color="black"
    dark
    class="text-center"
  >

  <v-container>
    <v-layout>
      <v-flex pa-10>
        <small>© Copyright by LedgerDex.com</small>
        <div v-if="isProductionCode">
          <div v-html="config.statCounterTrackingCode"></div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>

  </v-footer>

</template>

<script>
import { config } from '@/config'
import { isProductionCode } from '@/utils/utils'
export default {
  name: 'FooterPublic',
  data () {
    return {
      config: config,
    }
  },
  computed: {
    isProductionCode: isProductionCode
  },
}
</script>
